import * as React from 'react';

import { LABELS_BY_FIELD_NAME } from '../../maps';

import { CustomFormField as CustomFormFieldComponent } from './CustomFormField';
import { ICustomFormFieldPropsContainer } from './types';

export const CustomFormFieldContainer: React.FC<ICustomFormFieldPropsContainer> = props => {
  const {
    name,
    getFormFieldErrorMessage,
    getFormFieldRequired,
    getFormFieldVisible,
    // tslint:disable-next-line: trailing-comma
    ...otherProps
  } = props;

  const required = getFormFieldRequired(name);
  const visible = getFormFieldVisible(name);
  const errorMessage = getFormFieldErrorMessage(name);
  const label = LABELS_BY_FIELD_NAME[name];

  return (
    <CustomFormFieldComponent
      {...otherProps}
      required={required}
      hidden={!visible}
      errorMessage={errorMessage}
      label={label}
    />
  );
};

CustomFormFieldContainer.displayName = 'CustomFormFieldContainer';
